import React from 'react';
import { createRoot } from 'react-dom/client';

import './set-css-vars';
import { routes } from './client/assets/javascripts/constants/Misc';

const container = document.getElementById('app');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
const pathname = window.location.pathname.replace(/\/+$/, '');
const confirmPath = `/${routes.CONFIRM}`;
const verifyEmailPath = `/${routes.VERIFY_EMAIL}`;
const resetPasswordConfirmPath = `/${routes.RESET_PASSWORD_CONFIRM}`;
const recoverEmailPath = `/${routes.RECOVER_EMAIL}`;
const resetMfaPath = `/${routes.RESET_MFA}`;
const confirmRemovalPath = `/${routes.MFA_CONFIRM_REMOVAL}`;

if (pathname === confirmPath || pathname.endsWith(confirmPath)) {
  const FirebaseActionLanding =
    require('./client/assets/javascripts/containers/Login/FirebaseActionLanding').default;
  root.render(<FirebaseActionLanding />);
} else if (
  pathname === verifyEmailPath ||
  pathname.endsWith(verifyEmailPath)
) {
  const VerifyEmailConfirm =
    require('./client/assets/javascripts/containers/Login/VerifyEmailConfirm').default;
  root.render(<VerifyEmailConfirm />);
} else if (
  pathname === confirmRemovalPath ||
  pathname.endsWith(confirmRemovalPath) ||
  pathname === resetMfaPath ||
  pathname.endsWith(resetMfaPath)
) {
  const MfaConfirmRemoval =
    require('./client/assets/javascripts/containers/Login/MfaConfirmRemoval').default;
  root.render(<MfaConfirmRemoval />);
} else if (
  pathname === resetPasswordConfirmPath ||
  pathname.endsWith(resetPasswordConfirmPath)
) {
  const ResetPasswordConfirm =
    require('./client/assets/javascripts/containers/Login/ResetPasswordConfirm').default;
  root.render(<ResetPasswordConfirm />);
} else if (
  pathname === recoverEmailPath ||
  pathname.endsWith(recoverEmailPath)
) {
  const RecoverEmailConfirm =
    require('./client/assets/javascripts/containers/Login/RecoverEmailConfirm').default;
  root.render(<RecoverEmailConfirm />);
} else {
  const Root = require('./client/assets/javascripts/app/Root').default;
  root.render(<Root />);
}
